/**
 * Typed, non-PII FTUE analytics adapter.
 * V1 dispatches a namespaced browser CustomEvent so a future SDK can subscribe
 * without changing FTUE call sites.
 */

export const FTUE_EVENT_NAME = 'aleno:ops-ftue';

export type FtueAnalyticsEvent =
  | { type: 'ftue_welcome_shown'; version: number }
  | {
      type: 'ftue_start';
      version: number;
      source: 'auto' | 'help' | 'whats-new' | 'surface';
      journeyId: string;
    }
  | {
      type: 'ftue_step_viewed';
      version: number;
      stepId: string;
      index: number;
      journeyId: string;
    }
  | {
      type: 'ftue_skip';
      version: number;
      stepId: string | null;
      index: number;
      journeyId: string | null;
    }
  | { type: 'ftue_complete'; version: number; journeyId: string }
  | { type: 'ftue_help_open'; surface: string }
  | { type: 'ftue_help_target_open'; targetId: string; surface: string }
  | { type: 'ftue_catalog_open' }
  | { type: 'ftue_deep_dive_enter'; journeyId: string; fromStepId: string }
  | { type: 'ftue_deep_dive_exit'; journeyId: string }
  | { type: 'ftue_whats_new_shown'; version: number }
  | { type: 'ftue_whats_new_dismiss'; version: number };

export function emitFtueEvent(event: FtueAnalyticsEvent): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(
      new CustomEvent(FTUE_EVENT_NAME, {
        detail: { ...event, ts: Date.now() },
      }),
    );
  } catch {
    /* ignore */
  }
}
